module.exports = "<p> initial questionnaire works!!</p>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/views/patients/initial-questionnaire.component.html
// module id = ./src/app/views/patients/initial-questionnaire.component.html
// module chunks = main